import * as React from 'react'
import { useActions } from './useActions'
import { OppListProps } from './typings'
import { BulkAddOppsActivities, WWMXGrid } from '@user/components/xGrid'

import { GridState, GridDensity } from '@mui/x-data-grid-pro'
import { useSelector } from 'react-redux'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'

import {
  defaultOppColVis,
  lockedOpportunityColumns,
  defaultOpportunityColumns,
} from './opportunityListColumns'
import {
  BulkReassignOpps,
  BulkReopenOpps,
  BulkUpdateOppStatus,
  OpportunityBulkActions,
} from './OpportunityBulkActions'
import { BulkUpdateExpectedClosingDateOpps } from './OpportunityBulkActions/Sidebars/BulkUpdateExpectedClosingDateOpps'
import { BulkCloseWinOpps } from './OpportunityBulkActions/Sidebars/BulkCloseWinOpps'

import {
  userGeneralPreferencesList,
  IUserPreferenceGeneralListItemType,
  saveGeneralPreferences,
} from '@user/store/userPreferences/userPreferencesGeneral'

export function OpportunityList(props: OppListProps) {
  const {
    columns,
    rows,
    count,
    loading,
    page,
    perPage,
    columnVisibility,
    exportClickCallback,
  } = props

  const dispatch = useAppDispatch()

  const userGeneralPreferences = useSelector(userGeneralPreferencesList)

  const {
    handlePaginationModelChange,
    sortModel,
    onSortModelChange,
    onSaveColumnState,
    selectionChangeCallback,
    onColumnWidthChange,
  } = useActions(props)

  const createActivityBulkAction = BulkAddOppsActivities

  const densityModeUserGeneralPreference = userGeneralPreferences?.find(
    (row) =>
      row?.type == IUserPreferenceGeneralListItemType.OpportunityDensityMode,
  )

  const stringValue = densityModeUserGeneralPreference?.value ?? 'standard'
  const densityMode = stringValue as GridDensity

  const onStateChange = (state: GridState) => {
    if (state.density) {
      onDensityChange(state.density.value)
    }
  }

  const onDensityChange = (density: string) => {
    if (densityMode != density) {
      dispatch(
        saveGeneralPreferences({
          type: IUserPreferenceGeneralListItemType.OpportunityDensityMode,
          value: density,
        }),
      )
    }
  }

  return (
    <WWMXGrid
      loading={loading}
      // columns
      columnVisibilityModel={columnVisibility}
      columns={columns}
      onColumnWidthChange={(e) =>
        onColumnWidthChange(e?.colDef, columns, columnVisibility)
      }
      columnsSelectorProps={{
        defaultVisibility: defaultOppColVis,
        defaultColumns: defaultOpportunityColumns,
        lockedColumns: lockedOpportunityColumns,
        saveCallback: (e) => onSaveColumnState(e, columns),
      }}
      BulkActions={OpportunityBulkActions}
      bulkActionSidebars={{
        updateSalesFunnel: BulkUpdateOppStatus,
        reopen: BulkReopenOpps,
        reassign: BulkReassignOpps,
        updateExpectedClosingDate: BulkUpdateExpectedClosingDateOpps,
        closeWin: BulkCloseWinOpps,
        createActivity: createActivityBulkAction,
      }}
      //state
      isDensityEnable
      isExportEnable
      density={densityMode}
      onStateChange={onStateChange}
      //export
      exportClickCallback={exportClickCallback}
      // rows
      rows={rows}
      rowCount={count}
      // pagination
      paginationModel={{ page: page - 1, pageSize: perPage }}
      onPaginationModelChange={handlePaginationModelChange}
      // sorting
      sortModel={sortModel}
      onSortModelChange={onSortModelChange}
      selectionChangeCallback={selectionChangeCallback}
      width="100%"
    />
  )
}
